import {
    userApprovalsRoute,
    userApprovalsPendingPathRoute
} from "components/portal/userApprovals/UserApprovalsRoutes";

export const allUserApprovalsRoutes = (): any[] => {
    const routes = [
        userApprovalsRoute,
        userApprovalsPendingPathRoute
    ];
    return routes;
};
